import { Accordion, Card, Text, Image } from '@/ui'
import ReferralEmailForm from './ReferralEmailForm'

import { TypographyStyles } from '@/styles'

const Referrals = () => {
  return (
    <div>
      <div>
        <Text as={TypographyStyles.H1}>Rewards</Text>
      </div>
      <div className="flex gap-8 ">
        <div className="flex flex-col flex-2">
          <Card>
            <Text as={TypographyStyles.H2} className="pb-3">
              How it works
            </Text>
            <div className="flex gap-10">
              <Image
                alt="gift image"
                objectFit="contain"
                width={108}
                src="https://heard-images.s3.amazonaws.com/assets/giftbox.svg"
              />
              <Text
                as={TypographyStyles.BODY_MD}
                className="flex-1 leading-[150%]"
              >
                <ol className="list-decimal">
                  <li>Invite your friend(s) via email below.</li>
                  <li>
                    Your friend signs up for Heard&apos;s 30-day free trial from
                    the invite email.
                  </li>
                  <li>
                    You&apos;ll receive a $
                    {
                      process.env
                        .VITE_REFERRAL_FACTORY_REWARD_DOLLARS_SENDER_FIRST
                    }{' '}
                    gift card when your friend completes their 30-day free
                    trial, and then you&apos;ll receive another $
                    {
                      process.env
                        .VITE_REFERRAL_FACTORY_REWARD_DOLLARS_SENDER_SECOND
                    }{' '}
                    gift card once your friend stays an active member of Heard 2
                    months after their free trial ends — or right away if they
                    sign up for an annual plan.
                  </li>
                </ol>
              </Text>
            </div>
          </Card>
          <Card>
            <Text as={TypographyStyles.H2}>Refer a friend</Text>
            <ReferralEmailForm />
          </Card>
        </div>
        <div className="flex-1">
          <Card>
            <Text as={TypographyStyles.H2}>FAQs</Text>
            <Accordion type="multiple" collapsible variant="text">
              <Accordion.Item value="limit-referrals">
                <Accordion.Trigger>
                  <Text>Is there a limit to how many people I can refer?</Text>
                </Accordion.Trigger>
                <Accordion.Content>
                  <Text>
                    Nope! We&apos;re ready to grow and support therapists across
                    the country so refer as many friends as you&apos;d like.
                  </Text>
                </Accordion.Content>
              </Accordion.Item>
              <Accordion.Item value="when-do-i-get-my-rewards">
                <Accordion.Trigger>
                  <Text>When do I get my rewards?</Text>
                </Accordion.Trigger>
                <Accordion.Content>
                  <Text>
                    You&apos;ll receive your $
                    {
                      process.env
                        .VITE_REFERRAL_FACTORY_REWARD_DOLLARS_SENDER_FIRST
                    }{' '}
                    gift card once your friend completes their 30-day free
                    trial, and then you&apos;ll receive another $
                    {
                      process.env
                        .VITE_REFERRAL_FACTORY_REWARD_DOLLARS_SENDER_SECOND
                    }{' '}
                    gift card once your friend stays an active member of Heard 2
                    months after their free trial ends — or right away if they
                    sign up for an annual plan.
                  </Text>
                </Accordion.Content>
              </Accordion.Item>
              <Accordion.Item value="how-do-i-redeem-rewards">
                <Accordion.Trigger>
                  <Text>How do I redeem my rewards?</Text>
                </Accordion.Trigger>
                <Accordion.Content>
                  <Text>
                    You&apos;ll receive an email with instructions and a link to
                    your gift card.
                  </Text>
                </Accordion.Content>
              </Accordion.Item>
              <Accordion.Item value="why-did-i-not-receive-reward">
                <Accordion.Trigger>
                  <Text>Why didn&apos;t I receive my reward?</Text>
                </Accordion.Trigger>
                <Accordion.Content>
                  <div>
                    <Text>
                      There could be several reasons why you haven&apos;t
                      received your rewards:
                    </Text>
                  </div>
                  <ul className="list-disc pl-6">
                    <li>
                      <Text>
                        If you haven&apos;t received your first $
                        {
                          process.env
                            .VITE_REFERRAL_FACTORY_REWARD_DOLLARS_SENDER_FIRST
                        }{' '}
                        payment, your friend hasn&apos;t signed up or been a
                        Heard member for 30 days
                      </Text>
                    </li>
                    <li>
                      <Text>
                        If you haven&apos;t received your second $
                        {
                          process.env
                            .VITE_REFERRAL_FACTORY_REWARD_DOLLARS_SENDER_SECOND
                        }{' '}
                        payment, your friend hasn&apos;t been a Heard member for
                        at least 90 days yet (or, for annual plans, hasn&apos;t
                        yet converted from trial to paid)
                      </Text>
                    </li>
                    <li>
                      <Text>
                        Your friend might be ineligible to be a Heard member if
                        we can&apos;t support their practice needs for one or
                        more of the following reasons:
                        <ul className="list-disc pl-8">
                          <li>International taxes</li>
                          <li>Multiple practice owners</li>
                          <li>C-Corp tax entity</li>
                          <li>Practice with more than 10 employees</li>
                          <li>
                            Combined personal and business banking activity
                          </li>
                        </ul>
                      </Text>
                    </li>
                  </ul>
                </Accordion.Content>
              </Accordion.Item>
              <Accordion.Item value="new-customer-referral">
                <Accordion.Trigger>
                  <Text>
                    I&apos;m a new customer who has just joined Heard. Can I
                    still refer friends to join the platform?
                  </Text>
                </Accordion.Trigger>
                <Accordion.Content>
                  <Text>
                    Of course! We want you to share with your network to reach
                    and help as many therapists as we can.
                  </Text>
                </Accordion.Content>
              </Accordion.Item>
            </Accordion>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default Referrals
